const logo = require("../images/logoazul.png");

export default logo;
